import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Layout from "../../layout/Layout";
import PageBanner from "../../layout/PageBanner";
import { catalogService } from "../../services";
import { SkeletonGrid } from "../../components/ui";

export default function CardList() {
  const [rows, setRows] = useState(null);

  useEffect(() => {
    let alive = true;
    catalogService.cards().then((data) => alive && setRows(data || []));
    return () => {
      alive = false;
    };
  }, []);

  return (
    <Layout>
      <PageBanner title="บัตรเติมเงิน" breadcrumb={[{ label: "บัตรเติมเงิน" }]} seed={11} />

      <div className="lucid-container" style={{ marginTop: -30, position: "relative", zIndex: 3, paddingBottom: 40 }}>
        <div className="lt-panel">
          <div className="lt-panel__head">
            <span className="lt-step">1</span>
            <div>
              <h2 className="lt-panel__title">เลือกบัตรเติมเงินที่ต้องการ</h2>
              <p className="lt-panel__subtitle">รหัสบัตรออกอัตโนมัติทันทีที่ชำระเงินสำเร็จ</p>
            </div>
          </div>

          {rows === null ? (
            <SkeletonGrid count={6} height={190} />
          ) : (
            <div className="lt-tile-grid">
              {rows.map((item) => (
                <Link key={item.id} to={`/topup/card/${item.id}/${item.slug}`} className="lt-tile">
                  <div className="lt-tile__image">
                    <img src={item.image} alt={item.name} loading="lazy" />
                  </div>
                  <div className="lt-tile__name">{item.name}</div>
                </Link>
              ))}
            </div>
          )}
        </div>
      </div>
    </Layout>
  );
}
